import Vue from "vue";
import Router from "vue-router";
var layout = import("@/view/layout/Layout");
Vue.use(Router);


export default new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   redirect: '/login',
    //   hidden: true
    // },
    {
      path: "/home",
      name: "home",
      component: () => layout,
      meta: { title: "首页", },
      redirect: 'home/enterprise',
      hidden: false,
      children: [
        {
          path: "enterprise",
          name: "enterprise",
          meta: { title: "企业", icon:"menu-icon-enterprise" },
          component: () => import("@/view/pages/enterprise/enterprise.vue"),
          children: [
            {
              // hidden: true,
              path: "orgDetail",
              name: "orgDetail",
              meta: { title: "企业详情"},
              component: () => import("@/view/pages/enterprise/detail.vue")  
            }
          ]
        }
        // {
        //   hidden: true,
        //   path: "Detail",
        //   name: "Detail",
        //   meta: { title: "详情"},
        //   component: () => import("@/view/pages/enterprise/detail.vue")  
        // }
      ]
    },
    {
      
      path: "/account",
      name: "account",
      component: () => layout,
      hidden: false,
      children: [
        {
          path: "/account",
          name: "account",
          meta: { title: "账户",icon:"menu-icon-account" },
          component: () => import("@/view/pages/account/account.vue"),
          children: [
            {
              path: "AccountDetail",
              name: "AccountDetail",
              meta: { title: "企业详情"},
              component: () => import("@/view/pages/account/detail.vue")  
            }
          ]
        }
        
      ]
    },
    {
      path: "/roleMenu",
      name: "roleMenu",
      component: () => layout,
      hidden: false,
      children: [
        {
          path: "/roleMenu",
          name: "roleMenu",
          meta: { title: "角色菜单",icon:"menu-icon-role"},
          component: () => import("@/view/pages/roleMenu"),
        }
      ]
    },
    {
      path: "/notice",
      name: "notice",
      component: () => layout,
      hidden: false,
      children: [
        {
          path: "/notice",
          name: "notice",
          meta: { title: "公告",icon:"menu-icon-notice"},
          component: () => import("@/view/pages/notice/notice.vue"),
          children: [
            {
              path: "noticeForm",
              name: "noticeForm",
              meta: { title: "公告详情"},
              component: () => import("@/view/pages/notice/noticeForm.vue")  
            }
          ]
        }
        
      ]
    },
    
    {
      path: "/feedback",
      name: "feedback",
      component: () => layout,
      hidden: false,
      children: [
        {
          path: "/feedback",
          name: "feedback",
          meta: { title: "反馈意见",icon:"feedback" },
          component: () => import("@/view/pages/feedback/list.vue"),
          children: [
            {
              path: "docDetail",
              name: "docDetail",
              meta: { title: "帮助文档"},
              component: () => import("@/view/pages/helpDoc/detail.vue")  
            }
          ]
        }
      ]
    },
    {
      path: "/helpDoc",
      name: "helpDoc",
      component: () => layout,
      hidden: false,
      children: [
        {
          path: "/helpDoc",
          name: "helpDoc",
          meta: { title: "帮助文档",icon:"help-doc" },
          component: () => import("@/view/pages/helpDoc/list.vue"),
          children: [
            {
              path: "docDetail",
              name: "docDetail",
              meta: { title: "帮助文档"},
              component: () => import("@/view/pages/helpDoc/detail.vue")  
            }
          ]
        }
      ]
    },
    {
      path: "/updateLog",
      name: "updateLog",
      component: () => layout,
      hidden: false,
      children: [
        {
          path: "/updateLog",
          name: "updateLog",
          meta: { title: "升级文档",icon:"update-log1"},
          component: () => import("@/view/pages/updateLog/index.vue"),
          children: [
            {
              path: "updateForm",
              name: "updateForm",
              meta: { title: "文档详情"},
              component: () => import("@/view/pages/updateLog/logForm.vue")  
            }
          ]
        }
        
      ]
    },

    {
      path: "/updateFile",
      name: "updateFile",
      component: () => layout,
      hidden: false,
      children: [
        {
          path: "/updateFile",
          name: "updateFile",
          meta: { title: "更新文件",icon:"update-file"},
          component: () => import("@/view/pages/updateLog/updateFile.vue"),
          children: [
            {
              path: "updateForm",
              name: "updateForm",
              meta: { title: "上传文件"},
              component: () => import("@/view/pages/updateLog/updateForm.vue")  
            }
          ]
        }
        
      ]
    },
    {
      path: "/oplog",
      name: "oplog",
      component: () => layout,
      hidden: false,
      children: [
        {
          path: "/oplog",
          name: "oplog",
          meta: { title: "操作日志",icon:"oplog"},
          component: () => import("@/view/pages/oplog/index.vue"),
          // children: [
          //   {
          //     path: "index",
          //     name: "updateForm",
          //     meta: { title: "上传文件"},
          //     component: () => import("@/view/pages/updateLog/updateForm.vue")  
          //   }
          // ]
        }
        
      ]
    },
    // {
    //   path: "/vue-bootstrap",
    //   name: "vue-bootstrap",
    //   component: () => layout,
    //   hidden: false,
    //   meta: { title: "vue-bootstrap" },
    //   redirect: () =>import("@/view/pages/vue-bootstrap/VueBootstrap.vue"),
    //   children: [
    //     {
    //       path: "alert",
    //       name: "vue-bootstrap-alert",
    //       meta: { title: "alert" },
    //       component: () => import("@/view/pages/vue-bootstrap/Alert.vue")
    //     },
    //     {
    //       path: "badge",
    //       name: "vue-bootstrap-badge",
    //       meta: { title: "badge" },
    //       component: () => import("@/view/pages/vue-bootstrap/Badge.vue")
    //     },
    //     {
    //       path: "button",
    //       name: "vue-bootstrap-button",
    //       meta: { title: "button" },
    //       component: () => import("@/view/pages/vue-bootstrap/Button.vue")
    //     },
    //     {
    //       path: "button-group",
    //       name: "vue-bootstrap-button-group",
    //       meta: { title: "button-group" },
    //       component: () =>import("@/view/pages/vue-bootstrap/ButtonGroup.vue")
    //     },
    //     {
    //       path: "button-toolbar",
    //       name: "vue-bootstrap-button-toolbar",
    //       meta: { title: "button-toolbar" },
    //       component: () =>import("@/view/pages/vue-bootstrap/ButtonToolbar.vue")
    //     },
    //     {
    //       path: "card",
    //       name: "vue-bootstrap-card",
    //       meta: { title: "vue-bootstrap-card" },
    //       component: () => import("@/view/pages/vue-bootstrap/Card.vue")
    //     },
    //     {
    //       path: "carousel",
    //       name: "vue-bootstrap-carousel",
    //       meta: { title: "carousel" },
    //       component: () => import("@/view/pages/vue-bootstrap/Carousel.vue")
    //     },
    //     {
    //       path: "collapse",
    //       name: "vue-bootstrap-collapse",
    //       meta: { title: "collapse" },
    //       component: () => import("@/view/pages/vue-bootstrap/Collapse.vue")
    //     },
    //     {
    //       path: "dropdown",
    //       name: "vue-bootstrap-dropdown",
    //       meta: { title: "dropdown" },
    //       component: () => import("@/view/pages/vue-bootstrap/Dropdown.vue")
    //     },
    //     {
    //       path: "embed",
    //       name: "vue-bootstrap-embed",
    //       meta: { title: "embed" },
    //       component: () => import("@/view/pages/vue-bootstrap/Embed.vue")
    //     },
    //     {
    //       path: "form",
    //       name: "vue-bootstrap-form",
    //       meta: { title: "form" },
    //       component: () => import("@/view/pages/vue-bootstrap/Form.vue")
    //     },
    //     {
    //       path: "form-checkbox",
    //       name: "vue-bootstrap-form-checkbox",
    //       meta: { title: "form-checkbox" },
    //       component: () =>import("@/view/pages/vue-bootstrap/FormCheckbox.vue")
    //     },
    //     {
    //       path: "form-file",
    //       name: "vue-bootstrap-form-file",
    //       meta: { title: "form-file" },
    //       component: () => import("@/view/pages/vue-bootstrap/FormFile.vue")
    //     },
    //     {
    //       path: "form-group",
    //       name: "vue-bootstrap-form-group",
    //       meta: { title: "form-group" },
    //       component: () =>import("@/view/pages/vue-bootstrap/FormGroup.vue")
    //     },
    //     {
    //       path: "form-input",
    //       name: "vue-bootstrap-form-input",
    //       meta: { title: "form-input" },
    //       component: () =>import("@/view/pages/vue-bootstrap/FormInput.vue")
    //     },
    //     {
    //       path: "form-radio",
    //       name: "vue-bootstrap-form-radio",
    //       meta: { title: "form-radio" },
    //       component: () =>import("@/view/pages/vue-bootstrap/FormRadio.vue")
    //     },
    //     {
    //       path: "form-select",
    //       name: "vue-bootstrap-form-select",
    //       meta: { title: "form-select" },
    //       component: () =>import("@/view/pages/vue-bootstrap/FormSelect.vue")
    //     },
    //     {
    //       path: "form-textarea",
    //       name: "vue-bootstrap-form-textarea",
    //       meta: { title: "form-textarea" },
    //       component: () =>import("@/view/pages/vue-bootstrap/FormTextarea.vue")
    //     },
    //     {
    //       path: "image",
    //       name: "vue-bootstrap-image",
    //       meta: { title: "image" },
    //       component: () => import("@/view/pages/vue-bootstrap/Image.vue")
    //     },
    //     {
    //       path: "input-group",
    //       name: "vue-bootstrap-input-group",
    //       meta: { title: "input-group" },
    //       component: () =>import("@/view/pages/vue-bootstrap/InputGroup.vue")
    //     },
    //     {
    //       path: "jumbotron",
    //       name: "vue-bootstrap-jumbotron",
    //       meta: { title: "jumbotron" },
    //       component: () =>import("@/view/pages/vue-bootstrap/Jumbotron.vue")
    //     },
    //     {
    //       path: "layout-grid-system",
    //       name: "vue-bootstrap-layout-grid-system",
    //       meta: { title: "layout-grid-system" },
    //       component: () =>import("@/view/pages/vue-bootstrap/LayoutGridSystem.vue")
    //     },
    //     {
    //       path: "link",
    //       name: "vue-bootstrap-link",
    //       meta: { title: "link" },
    //       component: () => import("@/view/pages/vue-bootstrap/Link.vue")
    //     },
    //     {
    //       path: "list-group",
    //       name: "vue-bootstrap-list-group",
    //       meta: { title: "list-group" },
    //       component: () =>import("@/view/pages/vue-bootstrap/ListGroup.vue")
    //     },
    //     {
    //       path: "media",
    //       name: "vue-bootstrap-media",
    //       meta: { title: "media" },
    //       component: () => import("@/view/pages/vue-bootstrap/Media.vue")
    //     },
    //     {
    //       path: "modal",
    //       name: "vue-bootstrap-modal",
    //       meta: { title: "modal" },
    //       component: () => import("@/view/pages/vue-bootstrap/Modal.vue")
    //     },
    //     {
    //       path: "nav",
    //       name: "vue-bootstrap-nav",
    //       meta: { title: "nav" },
    //       component: () => import("@/view/pages/vue-bootstrap/Nav.vue")
    //     },
    //     {
    //       path: "navbar",
    //       name: "vue-bootstrap-navbar",
    //       meta: { title: "navbar" },
    //       component: () => import("@/view/pages/vue-bootstrap/Navbar.vue")
    //     },
    //     {
    //       path: "pagination",
    //       name: "vue-bootstrap-pagination",
    //       meta: { title: "pagination" },
    //       component: () =>
    //         import("@/view/pages/vue-bootstrap/Pagination.vue")
    //     },
    //     {
    //       path: "pagination-nav",
    //       name: "vue-bootstrap-pagination-nav",
    //       meta: { title: "pagination-nav" },
    //       component: () =>
    //         import("@/view/pages/vue-bootstrap/PaginationNav.vue")
    //     },
    //     {
    //       path: "popover",
    //       name: "vue-bootstrap-popover",
    //       meta: { title: "popover" },
    //       component: () => import("@/view/pages/vue-bootstrap/Popover.vue")
    //     },
    //     {
    //       path: "progress",
    //       name: "vue-bootstrap-progress",
    //       meta: { title: "progress" },
    //       component: () => import("@/view/pages/vue-bootstrap/Progress.vue")
    //     },
    //     {
    //       path: "spinner",
    //       name: "vue-bootstrap-spinner",
    //       meta: { title: "spinner" },
    //       component: () => import("@/view/pages/vue-bootstrap/Spinner.vue")
    //     },
    //     {
    //       path: "table",
    //       name: "vue-bootstrap-table",
    //       meta: { title: "table" },
    //       component: () => import("@/view/pages/vue-bootstrap/Table.vue")
    //     },
    //     {
    //       path: "tabs",
    //       name: "vue-bootstrap-tabs",
    //       meta: { title: "tabs" },
    //       component: () => import("@/view/pages/vue-bootstrap/Tabs.vue")
    //     },
    //     {
    //       path: "toasts",
    //       name: "vue-bootstrap-toasts",
    //       meta: { title: "toasts" },
    //       component: () => import("@/view/pages/vue-bootstrap/Toasts.vue")
    //     },
    //     {
    //       path: "tooltip",
    //       name: "vue-bootstrap-tooltip",
    //       meta: { title: "tooltip" },
    //       component: () => import("@/view/pages/vue-bootstrap/Tooltip.vue")
    //     }
    //   ]
    // },
    // {
    //   path: "/vuetify",
    //   name: "vuetify",
    //   meta: { title: "vuetify" },
    //   component: () => layout,
    //   hidden: false,
    //   redirect: () => import("@/view/pages/vuetify/Vuetify.vue"),
    //   children: [
    //     {
    //       path: "alerts",
    //       name: "vuetify-alerts",
    //       meta: { title: "alerts" },
    //       component: () => import("@/view/pages/vuetify/Alerts.vue")
    //     },
    //     {
    //       path: "avatars",
    //       name: "vuetify-avatars",
    //       meta: { title: "avatars" },
    //       component: () => import("@/view/pages/vuetify/Avatars.vue")
    //     },
    //     {
    //       path: "badges",
    //       name: "vuetify-badges",
    //       meta: { title: "badges" },
    //       component: () => import("@/view/pages/vuetify/Badges.vue")
    //     },
    //     {
    //       path: "buttons",
    //       name: "vuetify-buttons",
    //       meta: { title: "buttons" },
    //       component: () => import("@/view/pages/vuetify/Buttons.vue")
    //     },
    //     {
    //       path: "calendars",
    //       name: "vuetify-calendars",
    //       meta: { title: "calendars" },
    //       component: () => import("@/view/pages/vuetify/Calendars.vue")
    //     },
    //     {
    //       path: "cards",
    //       name: "vuetify-cards",
    //       meta: { title: "cards" },
    //       component: () => import("@/view/pages/vuetify/Cards.vue")
    //     },
    //     {
    //       path: "chips",
    //       name: "vuetify-chips",
    //       meta: { title: "chips" },
    //       component: () => import("@/view/pages/vuetify/Chips.vue")
    //     },
    //     {
    //       path: "dialog",
    //       name: "vuetify-dialog",
    //       meta: { title: "dialog" },
    //       component: () => import("@/view/pages/vuetify/Dialog.vue")
    //     },
    //     {
    //       path: "autocompletes",
    //       name: "vuetify-autocompletes",
    //       meta: { title: "autocompletes" },
    //       component: () =>import("@/view/pages/vuetify/forms/Autocompletes.vue")
    //     },
    //     {
    //       path: "file-inputs",
    //       name: "vuetify-file-inputs",
    //       meta: { title: "file-inputs" },
    //       component: () =>import("@/view/pages/vuetify/forms/FileInputs.vue")
    //     },
    //     {
    //       path: "forms",
    //       name: "vuetify-forms",
    //       meta: { title: "forms" },
    //       component: () => import("@/view/pages/vuetify/forms/Forms.vue")
    //     },
    //     {
    //       path: "selection-controls",
    //       name: "vuetify-selection-controls",
    //       meta: { title: "selection-controls" },
    //       component: () =>import("@/view/pages/vuetify/forms/SelectionControls.vue")
    //     },
    //     {
    //       path: "selects",
    //       name: "vuetify-selects",
    //       meta: { title: "selects" },
    //       component: () => import("@/view/pages/vuetify/forms/Selects.vue")
    //     },
    //     {
    //       path: "textareas",
    //       name: "vuetify-textareas",
    //       meta: { title: "textareas" },
    //       component: () =>import("@/view/pages/vuetify/forms/Textareas.vue")
    //     },
    //     {
    //       path: "text-fields",
    //       name: "vuetify-text-fields",
    //       meta: { title: "text-fields" },
    //       component: () =>import("@/view/pages/vuetify/forms/TextFields.vue")
    //     },
    //     {
    //       path: "simple-tables",
    //       name: "vuetify-simple-tables",
    //       meta: { title: "simple-tables" },
    //       component: () =>import("@/view/pages/vuetify/tables/SimpleTables.vue")
    //     },
    //     {
    //       path: "data-tables",
    //       name: "vuetify-data-tables",
    //       meta: { title: "data-tables" },
    //       component: () =>import("@/view/pages/vuetify/tables/DataTables.vue")
    //     },
    //     {
    //       path: "tabs",
    //       name: "vuetify-tabs",
    //       meta: { title: "tabs" },
    //       component: () => import("@/view/pages/vuetify/Tabs.vue")
    //     },
    //     {
    //       path: "timelines",
    //       name: "vuetify-timelines",
    //       meta: { title: "timelines" },
    //       component: () => import("@/view/pages/vuetify/Timelines.vue")
    //     },
    //     {
    //       path: "tooltips",
    //       name: "vuetify-tooltips",
    //       meta: { title: "tooltips" },
    //       component: () => import("@/view/pages/vuetify/Tooltips.vue")
    //     },
    //     {
    //       path: "treeview",
    //       name: "vuetify-treeview",
    //       meta: { title: "treeview" },
    //       component: () => import("@/view/pages/vuetify/Treeview.vue")
    //     }
    //   ]
    // },
    // {
    //   path: "/wizard",
    //   name: "wizard",
    //   hidden: false,
    //   meta: { title: "wizard" },
    //   component: () => layout,
    //   redirect: () => import("@/view/pages/wizard/Wizard.vue"),
    //   children: [
    //     {
    //       path: "wizard-1",
    //       name: "wizard-1",
    //       meta: { title: "wizard-1" },
    //       component: () => import("@/view/pages/wizard/Wizard-1.vue")
    //     },
    //     {
    //       path: "wizard-2",
    //       name: "wizard-2",
    //       meta: { title: "wizard-2" },
    //       component: () => import("@/view/pages/wizard/Wizard-2.vue")
    //     },
    //     {
    //       path: "wizard-3",
    //       name: "wizard-3",
    //       meta: { title: "wizard-3" },
    //       component: () => import("@/view/pages/wizard/Wizard-3.vue")
    //     },
    //     {
    //       path: "wizard-4",
    //       name: "wizard-4",
    //       meta: { title: "wizard-4" },
    //       component: () => import("@/view/pages/wizard/Wizard-4.vue")
    //     }
    //   ]
    // },
    // {
    //   path: "/error",
    //   name: "error",
    //   hidden: false,
    //   meta: { title: "error" },
    //   component: () => layout,
    //   redirect: () => import("@/view/pages/error/Error.vue"),
    //   children: [
    //     {
    //       path: "/mylogin",
    //       meta: { title: "login" },
    //       name: "mylogin",
    //       component: () => import("@/view/pages/login/login.vue")
    //     },
    //     {
    //       path: "error-1",
    //       name: "error-1",
    //       component: () => import("@/view/pages/error/Error-1.vue")
    //     },
    //     {
    //       path: "error-2",
    //       name: "error-2",
    //       meta: { title: "error-2" },
    //       component: () => import("@/view/pages/error/Error-2.vue")
    //     },
    //     {
    //       path: "error-3",
    //       name: "error-3",
    //       meta: { title: "error-3" },
    //       component: () => import("@/view/pages/error/Error-3.vue")
    //     },
    //     {
    //       path: "error-4",
    //       name: "error-4",
    //       meta: { title: "error-4" },
    //       component: () => import("@/view/pages/error/Error-4.vue")
    //     },
    //     {
    //       path: "error-5",
    //       name: "error-5",
    //       meta: { title: "error-5" },
    //       component: () => import("@/view/pages/error/Error-5.vue")
    //     },
    //     {
    //       path: "error-6",
    //       name: "error-6",
    //       meta: { title: "error-6" },
    //       component: () => import("@/view/pages/error/Error-6.vue"),
    //       children: [
    //         {
    //           path: "error-4",
    //           name: "error-4",
    //           meta: { title: "error-4" },
    //           component: () => import("@/view/pages/error/Error-4.vue")
    //         },
    //         {
    //           path: "error-5",
    //           name: "error-5",
    //           meta: { title: "error-5" },
    //           component: () => import("@/view/pages/error/Error-5.vue")
    //         },
    //       ]
    //     }
    //   ]
    // },
    // {
    //   path: "/",
    //   redirect: "/home",
    //   hidden: true,
    //   component: () => layout,
    // },
    {
      path: "/login",
      component: () => import("@/view/pages/auth/Auth"),
      children: [
        {
          name: "login",
          path: "/login",
          component: () => import("@/view/pages/auth/Login")
        },
        {
          name: "register",
          path: "/register",
          component: () => import("@/view/pages/auth/Register")
        }
      ]
    },
    {
      path: "*",
      hidden: true,
      redirect: "/404"
    },
    {
      // the 404 route, when none of the above matches
      hidden: true,
      path: "/404",
      name: "404",
      component: () => import("@/view/pages/error/Error-1.vue")
    }
  ]
});
